import React from 'react'
import { LuShoppingBag } from 'react-icons/lu'
import { Link, NavLink } from 'react-router-dom'

// import logo from "../../assets/logo.webp"
import logo from "../../assets/logo.png"
import { RiMenu2Fill } from 'react-icons/ri'

const toggleMenu = () => {
    const menu = document.querySelector('.menu-items')
    const menuOverlay = document.querySelector('.menu-overlay')
    if (window.innerWidth < 992) {
        menu.classList.toggle('active')
        menuOverlay.classList.toggle('active')
    }
}

const hideMenu = () => {
    const menu = document.querySelector('.menu-items')
    const menuOverlay = document.querySelector('.menu-overlay')
    if (window.innerWidth < 992) {
        menu.classList.remove('active')
        menuOverlay.classList.remove('active')
    }
}

const Header = () => {
    return (
        <>
            <div className="menu-overlay" onClick={toggleMenu}></div>
            <header className='flex justify-between items-center p-4 bg-[#FCFAF5]'>
                <div className="container mx-auto">
                    <div className="flex justify-between items-center">
                        {/* toggler */}
                        <button className='lg:hidden block' onClick={toggleMenu}>
                            <RiMenu2Fill className='text-3xl' />
                        </button>
                        <Link to='/' onClick={hideMenu}>
                            <img src={logo} className='logo lg:h-[30px] h-[20px]' alt="" />
                        </Link>
                        <NavLink onClick={hideMenu} to='/cart' className='text-black lg:hidden flex justify-start items-center gap-1 text-sm uppercase rounded-[4px] font-semibold'>
                            <LuShoppingBag className='text-xl' /> (0)
                        </NavLink>
                        <div className="flex lg:flex-row flex-col menu-items lg:relative absolute justify-end items-center gap-5">
                            <NavLink onClick={hideMenu} to='/how-it-works' className='text-black text-sm font-semibold'>How It Works</NavLink>
                            <NavLink onClick={hideMenu} to='/case-studies' className='text-black text-sm font-semibold'>Case Studies</NavLink>
                            {/*<NavLink onClick={hideMenu} to='/sign-in' className='text-black text-sm border uppercase px-4 py-2 rounded-[4px] font-semibold'>Sign In</NavLink>*/}
                            {/*<NavLink onClick={hideMenu} to='/digital-experience' className='text-white text-sm bg-black border uppercase px-4 py-2 rounded-[4px] font-semibold'>Shop smart Formats</NavLink>*/}
                            {/*<NavLink onClick={hideMenu} to='/cart' className='text-black lg:flex hidden justify-start items-center gap-1 text-sm uppercase rounded-[4px] font-semibold'>*/}
                            {/*    <LuShoppingBag className='text-xl' /> (0)*/}
                            {/*</NavLink>*/}
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default Header
